module.exports = __webpack_public_path__ + "static/media/eteva-white.c7248a92.png";